<form #formRef="ngForm">
	<bb-page-header [backOnMobile]="['/library/datafeeds']" [icon]="'table'" [title]="datafeed ? datafeed.name : 'DATAFEED' | translate">
		<ul class="tabs" *ngIf="datafeed">
			<li>
				<a [routerLink]="['/library/datafeed', activeId, 'metadata']" routerLinkActive="" [class.active]="activeTab === 'metadata'"><!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-tags"></i> {{ 'METADATA' | translate }}
				</a>
			</li>
		</ul>

		<bb-status *ngIf="datafeed" [(ngModel)]="datafeed.status" name="status" [valueOn]="'active'" [valueOff]="'inactive'" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate" ></bb-status>

	</bb-page-header>

	<div class="body-column tab-container">
		<datafeed-details-metadata *ngIf="datafeed" [isNew]="isNew"[form]="form" [datafeed]="datafeed" [hidden]="activeTab !== 'metadata'"></datafeed-details-metadata>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form" [entity]="datafeed">
	<span *ngIf="datafeed?.mediatype==='video'" class="action-button" [ngClass]="{'active': preview}" (click)="preview = !preview">{{ 'PREVIEW' | translate }}</span>
</bb-actions-bar>


